import FixedCash from "./FixedCash";
import LongTermIncentives from "./LongTermIncentives";
import ShortTermIncentives from "./ShortTermIncentives";
import SignOnBonus from "./SignOnBonus";
import OfferBenefits from "./Benefits";
import Summary from "./Summary";
import EmailPreview from "./EmailPreview";

export const panels = [
  {
    id: "1",
    header: "Fixed Cash / Guaranteed Cash",
    component: FixedCash,         // ✅ No <>
  },
  {
    id: "2",
    header: "Short Term Incentives (STI)",
    component: ShortTermIncentives,  // ✅ No <>
  },
  {
    id: "3",
    header: "Long Term Incentives (LTI)",
    component: LongTermIncentives,   // ✅ No <>
  },
  {
    id: "4",
    header: "Benefits",
    component: OfferBenefits,       // ✅ No <>
  },
  {
    id: "5",
    header: "Sign On / One time payment",
    component: SignOnBonus,         // ✅ No <>
  },
  {
    id: "6",
    header: "Summary",
    component: Summary,             // ✅ No <>
  },
  {
    id: "7",
    header: "Preview Email",
    component: EmailPreview,        // ✅ No <>
  },
];

